import styled, { keyframes, css } from 'styled-components';
import { mixins } from '@custom-components/css';

const stretchIn = css`
  ${keyframes`
  0%{
      width: calc(100% - ${mixins.pxToRem(80)});
  }
  100% {
      width: calc(100% - ${mixins.pxToRem(200)});
  }
  `}
`;

const stretchOut = css`
  ${keyframes`
  0%{
      width: calc(100% - ${mixins.pxToRem(200)});
  }
  100% {
      width: calc(100% - ${mixins.pxToRem(80)});
  }
  `}
`;

export const DesktopPageWrapper = styled.div`
  ${({ theme }) => `background: ${theme.lightText}`};
  width: 100vw;
  @media only screen and (min-width: 1024px) {
    width: calc(100% - ${mixins.pxToRem(80)});
    &.stretch-enter {
      width: calc(100% - ${mixins.pxToRem(80)});
    }
    &.stretch-enter-active {
      animation: ${stretchIn} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    }
    &.stretch-enter-done {
      width: calc(100% - ${mixins.pxToRem(200)});
    }
    &.stretch-exit {
      width: calc(100% - ${mixins.pxToRem(200)});
    }
    &.stretch-exit-active {
      animation: ${stretchOut} 0.4s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
    }
    &.stretch-exit-done {
      width: calc(100% - ${mixins.pxToRem(80)});
    }
  }
`;
